var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item',{staticClass:"d-md-down-none",on:{"click":_vm.newOrganization}},[_c('i',{staticClass:"fa fa-building pr-2"}),_vm._v(" Ny virksomhed ")])
}
var staticRenderFns = []

export { render, staticRenderFns }